import {
  IsString,
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  Length,
  IsNumberString,
  IsUUID,
} from 'class-validator';

import { t } from '@vk-hr-tek/core/translations';

import { UNEP_KONTUR_CODE_LENGTH } from '@app/constants';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

export class SignUnepDto {
  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
    groups: ['code-verify'],
  })
  @IsString({
    groups: ['code-verify'],
  })
  @Length(UNEP_KONTUR_CODE_LENGTH, UNEP_KONTUR_CODE_LENGTH, {
    message: () => t('PopupSignUNEPKontur.Error.Code'),
    groups: ['code-verify'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: () => t('PopupSignUNEPKontur.Error.Code'),
      groups: ['code-verify'],
    },
  )
  code: string;

  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  @IsUUID(undefined, {
    groups: ['form'],
  })
  eventId: string;

  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  @IsUUID(undefined, {
    groups: ['form'],
  })
  nodeId: string;

  @IsBoolean()
  @IsOptional()
  skipSms?: boolean;

  attributes?: FormAttributesRequest;
}
